import { observer } from 'mobx-react';
import * as React from 'react';
import { Route, RouteComponentProps } from 'react-router';
import { CreateOrEditManifest } from './CreateOrEditManifest';
import { FileSystemsView } from './FileSystemsView';
import { ManifestList } from './ManifestList';
import { ManifestStatus } from './ManifestStatus';

@observer
export class SoftwareUpdatesView extends React.Component {
    public render() {
        return (
            <>
                <Route path="/software-updates/file-systems" exact component={FileSystemsView} />
                <Route path="/software-updates/manifests" exact component={ManifestList} />
                <Route path="/software-updates/manifests/create" exact component={CreateOrEditManifest} />
                <Route path="/software-updates/manifests/:serial/create" exact component={CreateOrEditManifest} />
                <Route path="/software-updates/manifests/:guid/edit" exact component={CreateOrEditManifest} />
                <Route path="/software-updates/manifests/:guid/status" exact component={ManifestStatus} />
            </>
        );
    }
}
